import { useState, useEffect } from "react";
import usePrevious from "utils/hooks/usePrevious";

const useChangeRolesByCategory = ({
    currentUser = null,
    categoryId, 
    roleList,
    changeRoleField
}) => {
    const [rolesByCategory, setRolesByCategory] = useState([]);
    const prevCategoryId = usePrevious(categoryId);
    useEffect(() => {
        if (categoryId === 0)
            setRolesByCategory([]);
        if (!categoryId || prevCategoryId === categoryId) return;
        setRolesByCategory(roleList.filter(role => role.categoryId === categoryId));
        if (currentUser !== null && currentUser.role.id !== 0) return;
        changeRoleField(0, "");
    }, [categoryId]);
    useEffect(() => {
        if (rolesByCategory.length !== 1) return;
        const { id, name } = rolesByCategory[0];
        changeRoleField(id, name);
    }, [rolesByCategory]);
    return {
        rolesByCategory
    };
}
export default useChangeRolesByCategory;